import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Card,
  CardTitle,
  ContentMaxWidth,
  Muted,
  PageHeading,
  PageSubheading,
  Pill,
  Row,
  Stack,
} from '../../layout/styledComponents'

const sections = [
  { to: '/patient-home/profile/personal', icon: '👤', name: 'Personal details' },
  { to: '/patient-home/profile/family', icon: '👨‍👩‍👧', name: 'Family & profiles' },
  { to: '/patient-home/profile/notifications', icon: '🔔', name: 'Notification preferences' },
  { to: '/patient-home/profile/privacy', icon: '🔒', name: 'Privacy & data' },
]

export default function ProfileIndexPage() {
  const navigate = useNavigate()
  return (
    <ContentMaxWidth>
      <Stack $gap="24px">
        <div>
          <Pill>Profile</Pill>
          <PageHeading style={{ marginTop: 12 }}>Profile &amp; settings</PageHeading>
          <PageSubheading>Personal details, family members, preferences.</PageSubheading>
        </div>
        <Stack $gap="12px">
          {sections.map((s) => (
            <Card
              key={s.to}
              as="button"
              onClick={() => navigate(s.to)}
              style={{ textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit' }}
            >
              <Row $between>
                <Row $gap="14px">
                  <span style={{ fontSize: 24 }}>{s.icon}</span>
                  <CardTitle style={{ margin: 0 }}>{s.name}</CardTitle>
                </Row>
                <span aria-hidden style={{ color: '#6B7280', fontSize: 18 }}>›</span>
              </Row>
              <Muted style={{ marginTop: 8 }}>Tap to open.</Muted>
            </Card>
          ))}
        </Stack>
      </Stack>
    </ContentMaxWidth>
  )
}
